/**
 * Dashboard population selection (ROADMAP:40): which shop types the whole
 * page is scoped to. Same '1nl.auditor.' key prefix and try/catch shape as
 * currency/storage.ts -- kept out of that module because this is dashboard
 * state, not a display-currency concern.
 */
export const REPORT_TYPES_KEY = '1nl.auditor.reportTypes';

export const REPORT_TYPE_OPTIONS = ['live', 'demo', 'training'] as const;

/** Owner ruling: demo/training NEVER count toward money by default. */
export const DEFAULT_REPORT_TYPES: readonly string[] = ['live'];

/** Canonical order, unknown values dropped; an empty result falls back to
 *  the default (the zero-selection state is never valid). */
function normalize(types: readonly string[]): string[] {
  const wanted = new Set(types);
  const kept = REPORT_TYPE_OPTIONS.filter((t) => wanted.has(t));
  return kept.length > 0 ? [...kept] : [...DEFAULT_REPORT_TYPES];
}

export function loadReportTypes(): string[] {
  try {
    const raw = localStorage.getItem(REPORT_TYPES_KEY);
    if (raw === null) return [...DEFAULT_REPORT_TYPES];
    return normalize(raw.split(','));
  } catch {
    return [...DEFAULT_REPORT_TYPES];
  }
}

export function saveReportTypes(types: readonly string[]): void {
  try {
    localStorage.setItem(REPORT_TYPES_KEY, normalize(types).join(','));
  } catch {
    // Storage can be unavailable in privacy-restricted browsers.
  }
}

/** True when the selection is exactly the default Live-only population. */
export function isDefaultReportTypes(types: readonly string[]): boolean {
  return types.length === DEFAULT_REPORT_TYPES.length && types.every((t, i) => t === DEFAULT_REPORT_TYPES[i]);
}
